module.exports = __webpack_public_path__ + "assets/img/gift-5-d-a4a25822.png";